/* ============================================================
   NORTHSHEEP — Buy-box upsell quick-add
   The small "Add to cart" button on a single-variant buy-box upsell
   item adds that product's variant via the Shopify cart AJAX API and
   opens / refreshes Dawn's cart drawer. Multi-variant upsells use a
   plain "Choose options" link (no JS). Self-contained so it works
   regardless of the optional cart-upsell feature.
   ============================================================ */
(function () {
  if (window.__nsBuyboxUpsellLoaded) return;
  window.__nsBuyboxUpsellLoaded = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ns-buybox-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    var id = btn.getAttribute('data-ns-buybox-add');
    if (!id) return;

    btn.classList.add('is-loading');
    var cartDrawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.getElementById('main-cart-items');

    var sections = [];
    if (onCartPage) {
      sections = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
    } else if (cartDrawer && cartDrawer.getSectionsToRender) {
      sections = cartDrawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    } else {
      sections = ['cart-drawer', 'cart-icon-bubble'];
    }

    var body = new FormData();
    body.append('id', id);
    body.append('quantity', 1);
    body.append('sections', sections.join(','));
    body.append('sections_url', window.location.pathname);

    fetch((window.routes && routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (resp) {
        btn.classList.remove('is-loading');
        if (resp.status) return; // sold out / inventory error
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(resp); // opens + refreshes the drawer
          /* renderContents leaves the drawer's own is-empty class alone: into an
             empty basket the drawer opened in the empty layout, no header and
             squashed rows (29 Sep 2026). Dawn's form clears it itself. */
          cartDrawer.classList.toggle('is-empty', !!cartDrawer.querySelector('.drawer__inner-empty'));
        } else {
          window.location.reload();
        }
        /* A bare fetch fires none of Dawn's cart events, so anything that
           reacts to the cart — the free gift above all — would never learn
           this happened. No cartData: /cart/add.js returns the line item,
           not the cart, and a listener handed that would misread it. */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ns-buybox-upsell' });
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
      });
  });
})();
